export const cardConfigText = {
  claimEvent: 'Claim Events',
  dateRange: '01/01/2024 – 12/31/2024',
  trendGraphTitleFiASo: 'Total Market Share Trend (FI and ASO)',
  trendGraphTitleFi: 'Fully Insured (FI) Market Share Trend',
  estimatedDetails: 'Estimated Savings Details',
};

export const commonText = {
  export: 'Export',
  xlsxFileFormat: '.xlsx',
  all: 'All',
  eAndICommerCial: 'Commercial',
  mAndRMedicare: 'Medicare',
  cAndSMedicaid: 'Medicaid',
  unCategorized: 'Uncategorized',
  exchange: 'Individual Exchange',
  dual: 'Dual',
  unknown: 'Unknown',
  EI: 'Commercial',
  MR: 'Medicare',
  CS: 'Medicaid',
  errorSavingDoc: 'Error in while saving the document: ',
  TAX_ID: 'TAX_ID',
  HEALTH_SYSTEM: 'HEALTH_SYSTEM',
  errorWhileDeleting: 'Error in while deleting the document: ',
};

export const MAX_INLINE_CONTRACT_ID_SELECTIONS = 20;
